// @flow

import React, { type ComponentType } from 'react';
import { compose } from 'redux';
import StyledTooltip, { Bubble, Button } from './atoms';
import withUniqueId from '../withUniqueId/withUniqueId';
import withHandleComponentToggle from '../withHandleComponentToggle';

/* eslint-disable react/require-default-props */
type Props = {
  content: Array<string> | string,
  icon?: string,
  iconSize?: string,
  title: string,
  handleOpen: Function,
  open: boolean,
  id: number, // eslint-disable-line react/no-unused-prop-types
};

const Tooltip: ComponentType<Props> = ({
  title,
  content,
  icon,
  iconSize,
  open,
  handleOpen,
}: Props) => (
  <StyledTooltip
    height={iconSize}
  >
    <Button
      onClick={handleOpen}
      icon={icon}
      iconSize={iconSize}
    />
    {open && <Bubble
      title={title}
      text={content}
    />}
  </StyledTooltip>
);

export default compose(
  withUniqueId,
  withHandleComponentToggle('tooltip'),
)(Tooltip);
